module.exports = __webpack_public_path__ + "img/transfer_saldo.49a2320e.png";